import React, { useState, useEffect, useCallback } from 'react';
import { safeJson, networkMessage } from '../apiHelpers';

const C = {
  primary: '#0F6E56', primaryBg: '#E1F5EE', border: '#E3E1D9',
  text: '#1F1E1B', muted: '#5F5E5A', surface: '#F7F5F0',
  gold: '#91600C', danger: '#C0392B',
};

const API = '/api/freelance';

function authHeaders() {
  const t = localStorage.getItem('token') || '';
  return { 'Content-Type': 'application/json', ...(t ? { Authorization: `Token ${t}` } : {}) };
}

const btn = {
  fontSize: 11, padding: '4px 10px', border: `1px solid ${C.border}`,
  borderRadius: 6, background: '#fff', cursor: 'pointer', color: C.muted,
};

/**
 * Order cancel karne ka nizam.
 * Freelancer delivery se pehle rad kar sakta hai; baaqi soorat mein
 * darkhwast jati hai aur doosri party ki manzoori chahiye.
 */
export default function OrderCancel({ orderId, status, onChanged }) {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = useCallback(() => {
    fetch(`${API}/orders/${orderId}/cancel-status/`, { headers: authHeaders() })
      .then((r) => (r.ok ? r.json() : null))
      .then((j) => { if (j && !j.error) setD(j); })
      .catch(() => {});
  }, [orderId]);

  useEffect(() => { load(); }, [load]);

  if (!d) return null;
  if (!d.can_request && !d.can_decline_order && !d.pending) return null;

  const post = async (url, body, okMsg) => {
    setBusy(true);
    try {
      const res = await fetch(url, {
        method: 'POST', headers: authHeaders(), body: JSON.stringify(body || {}),
      });
      const j = await safeJson(res);
      if (!res.ok) throw new Error(j.error || 'Failed');
      if (okMsg) alert(okMsg);
      load();
      if (onChanged) onChanged();
    } catch (e) { alert(networkMessage(e)); }
    setBusy(false);
  };

  const declineOrder = () => {
    const reason = window.prompt(
      'Decline this order?\n\nThe client gets a full refund and this counts towards your cancellation rate.\n\nWhy are you declining?');
    if (!reason) return;
    if (reason.trim().length < 10) { alert('Please give a slightly longer reason.'); return; }
    post(`${API}/orders/${orderId}/decline/`, { reason },
         'Order declined. The client has been refunded.');
  };

  const requestCancel = () => {
    const reason = window.prompt(
      `Request cancellation?\n\nThe other person has ${d.pending ? '' : '3 days '}to reply. ` +
      `If they do not, it is accepted automatically.\n\nWhy?`);
    if (!reason) return;
    if (reason.trim().length < 10) { alert('Please give a slightly longer reason.'); return; }
    post(`${API}/orders/${orderId}/cancel-request/`, { reason },
         'Request sent. You will be notified when they reply.');
  };

  const reply = (action) => {
    if (action === 'accept') {
      if (!window.confirm('Accept the cancellation?\n\nThe order will be cancelled and the client fully refunded.')) return;
      post(`${API}/cancel-requests/${d.pending.id}/reply/`, { action: 'accept' },
           'Order cancelled and refunded.');
    } else if (action === 'decline') {
      const note = window.prompt('Why are you declining the cancellation?') || '';
      post(`${API}/cancel-requests/${d.pending.id}/reply/`, { action: 'decline', note });
    } else {
      if (!window.confirm('Withdraw your cancellation request?')) return;
      post(`${API}/cancel-requests/${d.pending.id}/reply/`, { action: 'withdraw' });
    }
  };

  // ---- koi pending darkhwast ----
  if (d.pending) {
    const p = d.pending;
    return (
      <div style={{ marginTop: 6, padding: '7px 10px', borderRadius: 7,
                    background: '#FDF0DD', border: `1px solid ${C.gold}` }}>
        <p style={{ margin: 0, fontSize: 11.5, fontWeight: 700, color: C.gold }}>
          {'\u26A0\uFE0F'} Cancellation requested by @{p.by}
        </p>
        <p style={{ margin: '3px 0', fontSize: 11.5, color: C.text }}>{p.reason}</p>

        {p.mine ? (
          <>
            <p style={{ margin: '3px 0', fontSize: 10.5, color: C.muted }}>
              Waiting for their reply. Accepted automatically after {p.auto_accept_days} days.
            </p>
            <button style={btn} disabled={busy} onClick={() => reply('withdraw')}>
              Withdraw request
            </button>
          </>
        ) : (
          <div style={{ display: 'flex', gap: 6, marginTop: 5, flexWrap: 'wrap' }}>
            <button
              style={{ ...btn, background: C.danger, color: '#fff', borderColor: C.danger, fontWeight: 700 }}
              disabled={busy} onClick={() => reply('accept')}>
              Accept &amp; refund
            </button>
            <button style={btn} disabled={busy} onClick={() => reply('decline')}>
              Decline
            </button>
            <span style={{ fontSize: 10, color: C.muted, alignSelf: 'center' }}>
              auto-accepts in {p.auto_accept_days} days
            </span>
          </div>
        )}
      </div>
    );
  }

  // ---- buttons ----
  return (
    <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginTop: 6 }}>
      {d.can_decline_order && (
        <button style={{ ...btn, color: C.danger, borderColor: C.danger }}
                disabled={busy} onClick={declineOrder}>
          Decline this order
        </button>
      )}
      {d.can_request && (
        <button style={btn} disabled={busy} onClick={requestCancel}>
          Request cancellation
        </button>
      )}
    </div>
  );
}
